import React from 'react';

import moment from 'moment';

export const formats = Object.freeze({
  default: 'DD/MM/YYYY',
  dateTime: 'DD/MM/YYYY HH:mm',
  short: 'Do MMMM YYYY',
  long: 'dddd Do MMMM YYYY',
  birthday: 'MMMM YYYY',
  monthAndYear: 'MMMM YYYY',
  day: 'dddd'
});

export type TFormat = keyof typeof formats;

export interface IProps {
  fallback?: React.ReactNode;
  format?: TFormat;
  skipUtc?: boolean;
  value: moment.MomentInput;
}

const DateLabelHooks: React.FC<IProps> = React.memo(({ fallback, format, skipUtc, value }) => {
  const selectedFormat = React.useMemo<string>(() => {
    return formats[format!];
  }, [format]);

  const content = React.useMemo<React.ReactNode>(() => {
    if (!value) {
      return value;
    }

    const date = skipUtc ? moment(value) : moment.utc(value);
    return date.isValid() ? date.format(selectedFormat) : fallback;
  }, [fallback, selectedFormat, skipUtc, value]);

  return <span>{content}</span>;
});

DateLabelHooks.defaultProps = {
  fallback: '',
  format: 'default',
  skipUtc: false
};

export default DateLabelHooks;
